/** Shared UnifiedNavbar geometry — keep in sync across all layout shells. */
/** Fixed chrome flush to viewport top — use UNIFIED_NAVBAR_TOP_SPACING_CLASS for the inset above nav content. */
export const UNIFIED_NAVBAR_TOP_OFFSET_CLASS = "top-0";
/** Inset above nav row; lives inside the fixed chrome so scroll glass can cover it. */
export const UNIFIED_NAVBAR_TOP_SPACING_CLASS = "pt-3 md:pt-5 lg:pt-2";
export const UNIFIED_NAVBAR_PADDING_CLASS = "py-2 lg:py-1";
/** Shared pill-shaped navbar control chrome (e.g. login CTA). */
export const NAVBAR_PILL_CHROME_CLASS =
  "inline-flex items-center justify-center rounded-full px-3.5 py-1.5 text-center text-xs leading-snug shadow-sm transition-colors sm:px-4 sm:text-[0.8125rem]";
/** Navbar content offset below fixed chrome. */
export const UNIFIED_NAVBAR_CONTENT_OFFSET_CLASS = "pt-16";

const announcementStack = "max(var(--announcement-bar-height,0px),var(--announcement-bar-fallback-height,0px))";

/** Navbar + embedded announcement bar below it (announcement does not push navbar down). */
export const UNIFIED_NAVBAR_ANNOUNCEMENT_CONTENT_OFFSET_CLASS =
  `pt-[calc(4rem+${announcementStack})]`;

/** @deprecated Use UNIFIED_NAVBAR_ANNOUNCEMENT_CONTENT_OFFSET_CLASS — same stack model. */
export const UNIFIED_NAVBAR_HOME_ANNOUNCEMENT_CONTENT_OFFSET_CLASS =
  UNIFIED_NAVBAR_ANNOUNCEMENT_CONTENT_OFFSET_CLASS;

/** Reserve space above the fixed mobile bottom nav pill (footer/legal strip). */
export const MOBILE_BOTTOM_NAV_CLEARANCE_CLASS =
  "pb-[calc(4.25rem+env(safe-area-inset-bottom,0px))]";

/** Frosted glass layer behind fixed UnifiedNavbar content. */
export const UNIFIED_NAVBAR_GLASS_BASE_CLASS =
  "pointer-events-none absolute inset-0 -z-10 border-0 backdrop-blur-xl supports-[backdrop-filter]:backdrop-blur-xl";
export const UNIFIED_NAVBAR_GLASS_BRIGHT_CLASS =
  "bg-white/75";
export const UNIFIED_NAVBAR_GLASS_DARK_CLASS =
  "bg-black/30";
export const UNIFIED_NAVBAR_SOLID_BLACK_CLASS = "bg-black";
